/* eslint-disable no-undef */
export const fetch = {
	base: process.env.REACT_APP_DOMAIN,
	video: process.env.REACT_APP_VIDEO,
};
